module.exports = __webpack_public_path__ + "static/media/DSC_2620_s.d7fb5be8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/DSC_2620_s.jpg
// module id = 366
// module chunks = 0